import { readPlanningStatuses } from './read'

export const planningStatuses = {
  readCollection: readPlanningStatuses,
}
